




















































































import { computed, defineComponent, watch } from '@vue/composition-api';
import { useToast } from '@getaccept/lib-shared/src/toast';
import type { PropType } from 'vue';
import { InputType } from '@getaccept/lib-ui';
import Consent from '../../lobby/components/Consent.vue';
import type { VerifyLinkResponse } from '../../api/universal-link/types/verify-link-response';
import { useIdentifyRecipient } from './composables/identify-recipient.composable';

export default defineComponent({
  name: 'IdentifyRecipientDsrModal',
  components: {
    Consent,
  },
  props: {
    verifyLinkResponse: {
      type: Object as PropType<VerifyLinkResponse>,
      required: true,
    },
    logoUrl: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { toast } = useToast();

    const {
      consentStep,
      submitDisabled,
      helpMessage,
      errorMessage,
      loadingRedirectURL,
      setConsent,
      submit,
      consentGiven,
      recipient,
    } = useIdentifyRecipient(props.verifyLinkResponse);

    const disabled = computed(
      () => submitDisabled.value || !recipient.value.firstName || !recipient.value.lastName
    );

    watch(errorMessage, () => {
      if (errorMessage.value) {
        toast.danger(errorMessage.value);
      }
    });

    return {
      consentStep,
      submitDisabled,
      helpMessage,
      errorMessage,
      loadingRedirectURL,
      setConsent,
      submit,
      consentGiven,
      recipient,
      disabled,
      InputType,
    };
  },
});
